<template>
  <div class="pop-drag" :style="isOpen ? 'display:block' : 'display:none'">
    <div class="popup-mask"></div>
    <div class="pop-content pop-ani pop-drag" style="width:90%;">
      <div class="pop-head">
        <h2>Template</h2>
        <button class="btn-x" @click="doClose()"></button>
      </div>
      <div class="pop-body" ref="popBody">
        <table class="table-style-default table-pop">
          <colgroup>
            <col width="116px" />
            <col width="*" />
          </colgroup>
          <tbody>
            <tr>
              <td style="background-color: #F6F6F6;">
                <span style="white-space: nowrap"> Fhir<br />Template </span>
              </td>
              <td>
                <pre
                  ref="fhirTemplate"
                  style="white-space: pre-wrap; max-height: 500px; overflow-y: scroll;"
                ><input type="button" class="copy-img" @click="doCopy(null)" />{{
                    getJSONPrettyPrint(templateInfo.fhirTemplate) || '-'
                  }}</pre>
              </td>
            </tr>
            <tr
              v-for="(item, index) in templateInfo.simplePhrRequest"
              :key="index"
            >
              <td style="background-color: #F6F6F6;">
                <span style="white-space: nowrap">
                  SimplePHR<br />Template
                  {{
                    templateInfo.simplePhrRequest.length == 1 ? '' : index + 1
                  }}
                </span>
              </td>
              <td>
                <pre
                  ref="simplePhr"
                  style="white-space: pre-wrap; max-height: 500px; overflow-y: scroll;"
                ><input type="button" class="copy-img" @click="doCopy(index)" />{{
                    getJSONPrettyPrint(item) || '-'
                  }}</pre>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from '@/mixins/CommonMixins';
export default {
  mixins: [mixins],
  props: {
    isOpen: {
      required: true,
      type: Boolean,
      default: false,
    },
    templateInfo: {
      requires: true,
      type: Object,
    },
  },
  data() {
    return {
      item: {},
    };
  },
  methods: {
    doCopy(idx) {
      // for문으로 열을 생성하는 simplePHR의 경우, 복사 대상 타겟팅하기 위해 인덱스 필요
      let target =
        idx !== null
          ? this.$refs['simplePhr'][idx]
          : this.$refs['fhirTemplate'];
      this.$copyText(target).then(
        function(e) {
          // 선택영역(드래그) 초기화
          e.clearSelection();
        },
        function(e) {
          console.log('error', e);
        },
      );
    },
    doClose() {
      // 스크롤 Top 이동
      this.$refs.fhirTemplate.scrollTop = 0;
      this.$refs.popBody.scrollTop = 0;
      this.$emit('close', false);
    },
  },
};
</script>
<style scoped>
.copy-img {
  width: 24px;
  height: 24px;
  background: url('../../../assets/images/icons8-copy-24.png');
  display: block;
  float: right;
  margin-right: 20px;
  margin-top: 10px;
}
</style>
